import React from "react";
import {
  Box,
  Button,
  Circle,
  Flex,
  Heading,
  Input,
  Text,
  Textarea,
} from "@chakra-ui/react";
import heading from "@fontsource/epilogue";
import bodyfont from "@fontsource/roboto";
import { Link } from "react-router-dom";
import Navbar from "../../../Components/Recruiter/Navbar/Navbar";

const Post_newJob = () => {
  return (
    <div>
      <Box>
        <Flex
          h="80vh"
          w="100%"
          align="center"
          justify="center"
          flexDirection="column"
          gap={20}
        >
          {/* Heading */}
          <Box>
            <Heading
              fontSize={[32, 32, 64, 64]}
              fontWeight="extrabold"
              fontFamily={"Epilogue"}
            >
              Create new job post
            </Heading>
          </Box>
          {/* Post Job Button */}
          <Box>
            <Link to="/hiring/recruiter/createPost">
              <Flex
                align="center"
                w={340}
                justify="center"
                h={47}
                borderRadius={12}
                bg="#6C56FB"
                _hover={{
                  boxShadow: "0px 8px 24px rgba(108, 86, 251, 0.2)",
                }}
                transition="0.2s"
                cursor="pointer"
              >
                <Text
                  color="#FFFFFF"
                  fontSize={20}
                  fontWeight="500"
                  fontFamily={"Roboto"}
                  letterSpacing={"0.04em"}
                >
                  Create Post
                </Text>
              </Flex>
            </Link>
          </Box>
        </Flex>
      </Box>
    </div>
  );
};
export default Post_newJob;
